import { V1_API_URL_PREFIX } from '../Constants';
import {request} from "./ApiUtils";

export function imsAuditChecklist() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist",
        method: 'GET'
    });
}

export function imsAuditChecklistRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateImsAuditChecklist(record) {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function addImsAuditChecklistRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/ims-audit-checklist/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}
